export default __webpack_public_path__ + "static/media/pot5.f4e0b62e.svg";